module.exports = __webpack_public_path__ + "static/media/USDT_BUSD_APE.599f9acb.png";